import useChatStore from '@/stores/chat'
import { storeToRefs } from 'pinia'
import { chatApi } from '@/api/chat'
import { cloneDeep } from 'lodash-es'
import { nextTick, onMounted, computed, ref } from 'vue'
import { messageBoxScroll2Bottom } from '@/utils/chat'
import { message } from 'ant-design-vue'
import { chatsMap } from '@/utils/constant'
import router from '@/router'

export enum EnumChatName {
  isNormal = 0,
  isEdit = 1,
  isDeleted = 2
}
export enum Editflag {
  confirm = 0,
  cancel = 1,
  edit = 2,
  delete = 3
}
export const useInfo = (props: any) => {
  const chatStores = useChatStore()
  const { isShowHistory, sessionList, curSelectSession, isSending, showScrollToBottom } =
    storeToRefs(chatStores)

  const isLoading = ref(false)
  const getMessageList = async (sessionId) => {
    const data = await chatApi.getMessageList({
      session_id: sessionId
    })
    const map = data.data.list
    Object.keys(map).map((key) => {
      map[key].isFromList = true
      map[key].nameEditState = EnumChatName.isNormal
      // 内容输出完成
      map[key].is_end = true

      if (map[key].forms) {
        map[key].text_type = 2
      }
      if (map[key].text_type == 2) {
        // 表单
        map[key].editCnt = 1
        map[key].isPreview = true
        map[key].originForms = cloneDeep(map[key].forms)
      }
    })
    chatStores.updateMapping(map)
    nextTick(() => {
      messageBoxScroll2Bottom()
    })
  }

  const getChatLists = (isNew = false) => {
    isLoading.value = true
    chatApi.getChatLists({}).then((res) => {
      isLoading.value = false
      const list: any = res.data.list.map((item, index) => {
        item.nameEditState = 0
        if (isNew && index == 0) {
          item['isActive'] = true
        } else {
          item['isActive'] = false
        }
        return item
      })

      chatStores.updateSessionList(list)
    })
  }
  function setSessionActive(cutItem) {
    sessionList.value = sessionList.value.map((item, index) => {
      let isActive = false
      if (cutItem.session_id && item.session_id == cutItem.session_id) {
        isActive = true
      }

      item['isActive'] = isActive
      return item
    })
    chatStores.updateSessionList(sessionList.value)
  }
  const sessionClick = (item, index) => {
    if (isSending.value) {
      message.info(chatsMap.sendingTips)
      return
    }
    if (item['isActive']) {
      return
    }
    setSessionActive(item)
    // if (chatStores.controller) {
    //   chatStores.controller.abort()
    // }
    chatStores.$patch((state) => {
      state.curSelectSession = item
      state.isSending = false
      state.isNewchat = false
    })

    getMessageList(item.session_id)
    router.push('/chat')
  }
  const modifySessionName = (item) => {
    if (!item.new_session_name) {
      message.error('名称不能为空~')
      return
    }
    chatApi
      .modifySessionName({
        name: item.new_session_name,
        session_id: item.session_id
      })
      .then((res) => {
        item.session_name = item.new_session_name
      })
  }
  onMounted(() => {
    getChatLists()
  })
  const itemEdit = (item) => {
    item.nameEditState = EnumChatName.isEdit
    item.new_session_name = item.session_name
  }
  const editName = (flag, item) => {
    switch (flag) {
      case Editflag.confirm:
        modifySessionName(item)
        item.nameEditState = EnumChatName.isNormal
        break
      case Editflag.cancel:
        item.nameEditState = EnumChatName.isNormal
        item.new_session_name = ''
        break
    }
  }
  const groupList = computed(() => {
    const groups: any = [
      {
        name: '近7天',
        list: []
      },
      {
        name: '近30天',
        list: []
      },
      {
        name: '30天前',
        list: []
      }
    ]
    sessionList.value.map((item: any) => {
      if (item.group_time == 1) {
        groups[0].list.push(item)
      } else if (item.group_time == 2) {
        groups[1].list.push(item)
      } else {
        groups[2].list.push(item)
      }
    })
    return groups.filter((list: any) => {
      return list.list.length > 0
    })
  })
  const deleteSession = (item) => {
    if (chatStores.isSending) {
      message.error('正在对话中，无法进行删除~')
      return
    }
    chatApi
      .deleteSession({
        session_id: item.session_id
      })
      .then((res) => {
        getChatLists()
        chatStores.updateIsNewChat(true)
        chatStores.updateMapping({})
        chatStores.updateCurSelectSession({
          sesssion_id: ''
        })
      })
  }
  const rowMouseEnter = (item) => {
    if (isSending.value) {
      item.isNotAllowed = true
      return
    }
    item.isHoverd = true
  }
  const rowMouseLeave = (item) => {
    item.isNotAllowed = false
    item.isHoverd = false
  }
  const shrink = () => {
    isShowHistory.value = !isShowHistory.value
  }
  return {
    isShowHistory,
    groupList,
    curSelectSession,
    sessionClick,
    rowMouseEnter,
    rowMouseLeave,
    itemEdit,
    editName,
    deleteSession,
    shrink,
    isLoading
  }
}
